<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <h3 align="left">Agudeza visual:</h3>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-row>
      <v-col
        v-for="eye in model.evaluations"
        :key="eye.bodyPart.idBodyPart"
        cols="6"
        sm="12"
        md="6"
        lg="6"
        @click.right.prevent
        @copy.prevent
        @paste.prevent
        ondrop="return false;"
      >
        <div class="text-subtitle-1">{{ eye.bodyPart.name }}</div>
        <validation-provider
          v-slot="{ errors, invalid, touched }"
          :name="eye.bodyPart.name"
          rules="max:300"
        >
          <v-textarea
            
            outlined
            clearable
            :clear-icon="$cnst.CLEAR_ICON"
            :disabled="isViewDetailsForm"
            v-model="eye.note"
            :counter="300"
            :error-messages="errors"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-textarea>
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  props: {
    model: Object,
    listEyesInformation: Array,
    isViewDetailsForm: Boolean,
  },
  components: {
    ValidationProvider,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style></style>
